export default __webpack_public_path__ + "static/media/unexploitableIconEmpty.67740c67.svg";